// Barra fina segmentada no topo: um segmento por passo visível.
// Já percorridos = dourado; os demais = branco 18%.
export default function BarraProgresso({ total, atual }: { total: number; atual: number }) {
  return (
    <div
      className="flex flex-1 items-center gap-1"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={atual + 1}
    >
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className="h-1 flex-1 rounded-full transition-colors duration-300"
          style={{ backgroundColor: i <= atual ? 'var(--ouro)' : 'rgba(255,255,255,.18)' }}
        />
      ))}
    </div>
  );
}